<!-- 
    说明：弹窗组件
    创建时间：2022/7/29
    创建者：congpeizhi
-->
<template>
    <div class="popup">
        <sp-popup
            position="bottom"
            :disable-scroll="true"
            v-model="rightsVisible"
            :mask-closeable="true"
        >
            <div class="popup-content">
                <div class="popup-content-title">
                    <span>{{ title }}</span>
                    <img
                        class="popup-content-close"
                        src="../../img/close1.png"
                        @click="closePop"
                    />
                </div>
                <div class="popup-content-inner">
                    <slot></slot>
                </div>
                <div class="popup-content-bottom" v-if="btnText">
                    <div class="popup-content-bottom_btn" @click="checkBtn">
                        {{ btnText }}
                    </div>
                </div>
            </div>
        </sp-popup>
    </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { Popup } from '@lux/sharp-ui-next';
export default defineComponent({
    components:{
        'sp-popup': Popup,
    },
    props: {
        // 弹窗标题
        title: {
            type: String,
            default: '基础权益',
        },
        // 底部按钮文案
        btnText: {
            type: String,
            default: '',
        },
    },
    emits: ['popUpBottom'],
    setup(props, ctx) {
        // 控制是否展示弹窗
        const rightsVisible = ref(false);
        // 点击关闭按钮触发关闭
        const closePop = () => {
            rightsVisible.value = false;
        };
        // 展示弹窗
        const showPopUp = () => {
            rightsVisible.value = true;
        };
        // 点击底部按钮触发事件
        const checkBtn = () => {
            ctx.emit('popUpBottom');
        };
        return {
            rightsVisible,
            closePop,
            showPopUp,
            checkBtn,
        };
    },
});
</script>

<style lang="less" scoped>
.popup-content {
    background-color: #fff;
    border-radius: 16px 16px 0 0;
    font-family: 'PingFang SC';
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: border-box;
    min-height: 61.8vh;
    max-height: 85vh;
    display: flex;
    flex-direction: column;
    .popup-content-title {
        font-family: 'PingFang SC';
        font-style: normal;
        font-weight: 500;
        font-size: 20px;
        line-height: 24px;
        text-align: center;
        color: #000;
        position: relative;
        padding-top: 40px;
    }
    .popup-content-close {
        width: 24px;
        position: absolute;
        top: 16px;
        right: 16px;
    }
    .popup-content-inner {
        flex: 1;
    }
    .popup-content-bottom {
        padding: 8px 0;
        &_btn {
            width: 376px;
            height: 44px;
            background: #fe3666;
            border-radius: 22px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: 500;
            font-size: 16px;
            color: #fff;
            margin: 0 auto;
        }
    }
}
</style>
